import { createFileRoute } from '@tanstack/react-router';

import { InvoicingPage } from '@/features/invoicing/components/invoicing-page';
import { invoicingSearchSchema } from '@/features/invoicing/constants/search-params';

// validateSearch parsea la URL y rechaza shapes inválidos. TanStack
// Router pasa el resultado tipado al componente vía useSearch().
export const Route = createFileRoute('/_app/facturacion/')({
  component: InvoicingPage,
  validateSearch: invoicingSearchSchema,
});
